export enum ESignWorkflowSessionStatus {
  INITIALIZING = "INITIALIZING",
  READY = "READY",
  START = "START",
  SIGNED = "SIGNED",
  COMPLETED = "COMPLETED",
  ERRORED = "ERRORED",
  INVALIDATED = "INVALIDATED",
}

// We don't want to consider these statuses when checking for a signable session
export const IGNORED_ESIGN_WORKFLOW_SESSION_STATUSES = [
  ESignWorkflowSessionStatus.ERRORED,
  ESignWorkflowSessionStatus.INVALIDATED,
] as const;

export const NON_SIGNABLE_ESIGN_WORKFLOW_SESSION_STATUSES = [
  ...IGNORED_ESIGN_WORKFLOW_SESSION_STATUSES,
  ESignWorkflowSessionStatus.COMPLETED,
  ESignWorkflowSessionStatus.SIGNED,
] as const;
